const homePage: Record<string, Record<string, string> | string> = {
    headerLinks: {
        requests: 'Предоставленные сведения',
        campaigns: 'Сборы сведений',
    },
};

export default homePage;
